export default "__VITE_ASSET__Do32bJjY__"